import { useMutation } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import getInstance from "../../../utils/rest";

const downloadReportingImportTemplate = async (contractNo: string, reportingNo: number, lang: "de" | "en"): Promise<void> => {
  const response = await getInstance().get(
    `${RestEndpoints.PomReportings}/${contractNo}/${reportingNo}/import-template?lang=${lang}`,
    { responseType: "blob" }
  );
  const disposition = response.headers["content-disposition"] as string | undefined;
  const filenameMatch = disposition?.match(/filename="?([^"]+)"?/);
  const filename = filenameMatch?.[1] ?? `template_${contractNo}_${reportingNo}.xlsx`;
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const useDownloadReportingImportTemplateMutation = () => {
  return useMutation({
    mutationFn: ({ contractNo, reportingNo, lang }: { contractNo: string; reportingNo: number; lang: "de" | "en" }) =>
      downloadReportingImportTemplate(contractNo, reportingNo, lang),
  });
};
